<template>
  <c-loading-area :loading="loading" :height="350" :card="false">
    <v-card class="pa-5">
      <div class="d-flex">
        <div class="text-right" style="flex: 0 0 auto">
          <v-icon color="icon" style="font-size:54px">
            mdi-bank
          </v-icon>
        </div>
        <v-divider vertical class="mx-6"/>
        <div style="flex: 1 1 auto">
          <div class="c-caption" style="font-size:1.3rem">
            {{ $t('page.manageFiling.origCourt.splash.origCourtCases.title') }}
          </div>
          <div class="font-weight-light" style="font-size: 1.35rem;max-width:80ch">
            {{ $t('page.manageFiling.origCourt.splash.origCourtCases.description') }}
          </div>
          <div class="mt-10">
            <c-btn large type="primary" style="min-width:160px" @click="$emit('addOrigCourtCase')">
              {{ $t('page.manageFiling.origCourt.splash.button.addOrigCourtCase') }}
            </c-btn>
            <c-btn v-if="shouldDisplayViewButton" large type="primary" style="min-width:160px"
                   @click="$emit('viewOrigCourtCases')">
              {{ $t('page.manageFiling.origCourt.splash.button.viewOrigCourtCases') }}
            </c-btn>
            <c-btn v-if="isStepComplete" large type="primary" style="min-width:160px" @click="$emit('continue')">
              {{ $t('global.skipThisStep') }}
            </c-btn>
          </div>
        </div>
      </div>
    </v-card>
  </c-loading-area>
</template>

<script>
import { useFilingStore } from '@/stores/filingStore';
import axios from 'axios';
import _ from 'lodash';

const filingStore = useFilingStore();

export default {
  data () {
    return {
      loading: true,
      hasAtLeastOneOrigCourt: false
    };
  },
  computed: {
    filingID () {
      return filingStore.filingID;
    },
    shouldDisplayViewButton () {
      return this.hasAtLeastOneOrigCourt;
    },
    isStepComplete () {
      return filingStore.isStepComplete(this.CONST.FILING_STEP_ORIGINATING_COURT);
    }
  },
  created () {
    this.loadOrigCourtCases();
  },
  methods: {
    loadOrigCourtCases () {
      this.loading = true;

      let url = this.$cove.getAPI({
        name: 'api.filing.originatingCourtCases',
        query: {
          filingID: this.filingID,
          size: 1,
          fields: '*'
        }
      });

      return axios.get(url).
        then((response) => {
          let origCourtCases = _.get(response, 'data._embedded.results', []);
          this.hasAtLeastOneOrigCourt = !_.isEmpty(origCourtCases);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>